var setval_read, setval_play, loadingType;
import {setPackReadTime, saveStudayTime} from '../service/getData';
import {pro_name} from '../config/env';
import {getCookie, sensorsEvent} from '../config/mUtils'

/**
 * 拆书包阅读及音频播放时长
 * 1、在页面跳转后记录时长并通过接口存储，成功后清理localstore
 * 2、页面直接退出后存储在localstore，下次进入拆书包页面，如果localstore存在，请求接口存储，不存在，直接重新开始计时
 * @param string type 存储时长类型('read' 阅读 'play' 音频播放)
 * @param int status 播放状态()
 * @param json packInfo 拆书包数据()
 * @param int setval_time 计时时长()
 */
export const getPackTime = (type,status,packInfo,ajaxUrl) => {
    //阅读时长
    if (type == 'read') {
        let readMsg = packInfo,
            read_time;
        if (status == '100') {
            if (setval_read) {
                clearInterval(setval_read);
            }
            readMsg.read_start_time = new Date().getTime();
            readMsg.read_end_time = 0;
            readMsg.read_time = 0;
            setStore('readMsg',readMsg);
            setval_read = setInterval(function() {
                readMsg = JSON.parse(getStore('readMsg'));
                if (readMsg) {
                    read_time = readMsg.read_time + 5000;
                    readMsg.read_start_time = new Date().getTime();
                    readMsg.read_end_time = new Date().getTime();
                    readMsg.read_time = read_time;
                    setStore('readMsg',readMsg);
                } else {
                    clearInterval(setval_read);
                }
            },5000)
            // （开始）音视频时长
            sensorsEvent({
                eventName: 'startStudyMedia',
                eventObject: {
                    media_type: packInfo.media_type,
                    media_time: JSON.parse(packInfo.media_time),
                    play_start_location_time: JSON.parse(packInfo.play_start_location_time),
                    play_end_location_time: JSON.parse(packInfo.play_end_location_time),
                    is_audition: packInfo.is_audition,
                    is_today_study: packInfo.is_today_study,
                    business_type: packInfo.business_type,
                    business_id: packInfo.plan_id,
                    collection_id: packInfo.pb_id,
                    chapter_id: packInfo.pack_id,
                    event_type: 2,
                }
            });
        }else {
            //文章阅读时长
            let readMsg = JSON.parse(getStore('readMsg'));
            if (readMsg) {
                let read_time = new Date().getTime() - readMsg.read_start_time + readMsg.read_time;
                clearInterval(setval_read);
                if( Math.ceil(read_time / 1000) < 3 ){
                    localStorage.removeItem('readMsg');
                    return
                }
                readMsg.read_end_time = new Date().getTime();
                readMsg.read_time = read_time;
                setStore('readMsg',readMsg);
                savePackTime('pack')
            } else {
                clearInterval(setval_read);
            }
        }
    } else if (type == 'play') {
        let playMsg,play_time;
        //音频播放时长
        if (status == '100') {
            if (setval_play) {
                clearInterval(setval_play);
            }
            if(getStore('playMsg')){
                savePackTime('pack_media')
            }
            playMsg = packInfo;
            playMsg.play_start_time = new Date().getTime();
            playMsg.play_end_time = 0;
            playMsg.play_time = 0;
            setStore('playMsg',playMsg);
            setval_play = setInterval(function() {
                playMsg = JSON.parse(getStore('playMsg'));
                if (playMsg) {
                    play_time = playMsg.play_time + 5000;
                    playMsg.play_start_time = new Date().getTime();
                    playMsg.play_end_time = new Date().getTime();
                    playMsg.play_time = play_time;
                    setStore('playMsg',playMsg);
                } else {
                    clearInterval(setval_play);
                }
            },5000)
            // （开始）音视频时长
            sensorsEvent({
                eventName: 'startStudyMedia',
                eventObject: {
                    media_type:packInfo.media_type ? packInfo.media_type : 'audio',
                    media_time:packInfo.media_time ? JSON.parse(packInfo.media_time) : 0,
                    play_start_location_time: JSON.parse(packInfo.play_start_location_time),
                    play_end_location_time: JSON.parse(packInfo.play_end_location_time),
                    is_audition: packInfo.is_audition,
                    is_today_study: packInfo.is_today_study,
                    business_type: packInfo.business_type,
                    business_id: packInfo.plan_id,
                    collection_id: packInfo.pb_id,
                    chapter_id: packInfo.pack_id,
                    event_type:2,
                }
            });
        }else if(status=='200' || status=='1000') {
            //暂停 or 返回
            clearInterval(setval_play);
            playMsg = JSON.parse(getStore('playMsg'));
            if (playMsg) {
                play_time = new Date().getTime() - playMsg.play_start_time + playMsg.play_time;
                playMsg.play_start_time = new Date().getTime();
                playMsg.play_end_time = new Date().getTime();
                playMsg.play_time = play_time;
                playMsg.play_end_location_time = packInfo.play_end_location_time;
                setStore('playMsg',playMsg);
                savePackTime('pack_media')
            }
        } else if (status == '300') {
            //点击音频进度 or 拖动音频进度 初始化计时器
            clearInterval(setval_play);
            playMsg = JSON.parse(getStore('playMsg'));
            if (playMsg) {
                playMsg.play_start_time = new Date().getTime();
                playMsg.play_end_time = new Date().getTime();
                playMsg.play_time = playMsg.play_time;
            }else {
                playMsg={
                    plan_id:packInfo.plan_id,
                    pb_id:packInfo.pb_id,
                    pack_id:packInfo.pack_id,
                    play_start_time:new Date().getTime(),
                    play_end_time:0,
                    play_time:0
                };
            }
            setStore('playMsg',playMsg);
            setval_play = setInterval(function(){
                playMsg =JSON.parse(getStore('playMsg'));
                if (playMsg) {
                    play_time=playMsg.play_time + 5000;
                    let playMsg={
                        plan_id:packInfo.plan_id,
                        pb_id:packInfo.pb_id,
                        pack_id:packInfo.pack_id,
                        play_start_time:new Date().getTime(),
                        play_end_time:new Date().getTime(),
                        play_time:play_time
                    };
                    setStore('playMsg',playMsg);
                } else {
                    clearInterval(setval_play);
                }
            },5000)
        }
    }

}
/**
 * 初始化页面检测是否有未存储的时间
 */
export const savePackTime = (type) => {
    // 学习时长
    let readStore = JSON.parse(getStore('readMsg')),
        playStore = JSON.parse(getStore('playMsg')),
        studyInfo = {};
    if ((type == 'pack' && readStore) || (!type && readStore)) {
        if( Math.ceil(readStore.read_time / 1000) < 3 || Math.ceil(readStore.read_time / 1000) > 5000){
            localStorage.removeItem('readMsg');
            return;
        }
        studyInfo = readStore;
        studyInfo.studyTime = Math.ceil(readStore.read_time / 1000)
        saveTime(type ? type : 'pack', studyInfo);
    }

    if ((type == 'pack_media' && playStore) || (!type && playStore)) {
        if( Math.ceil(playStore.play_time / 1000) < 3 || Math.ceil(playStore.play_time / 1000) > 5000){
            localStorage.removeItem('playMsg');
            return;
        }
        studyInfo = playStore;
        studyInfo.studyTime = Math.ceil(playStore.play_time / 1000);
        saveTime(type ? type : 'pack_media', studyInfo);
    }
}

function saveTime(type, studyInfo) {
    let is_finished = 0;

    if (loadingType == type) {
        return
    } else {
        loadingType = type;
    }
    if (studyInfo.media_type == 'short_video') {
        clearInterval(setval_play);
        localStorage.removeItem('playMsg');
        is_finished = (Number(studyInfo.play_end_location_time) / Number(studyInfo.media_time)) > 0.9 ? 1 : 0
        loadingType = ''
        sensorsEvent({
            eventName: 'endStudyMedia',
            eventObject: {
                media_type:studyInfo.media_type ? studyInfo.media_type : 'audio',
                media_time:studyInfo.media_time && type == 'pack_media' ? JSON.parse(studyInfo.media_time) : 0,
                play_start_location_time: JSON.parse(studyInfo.play_start_location_time),
                play_end_location_time: JSON.parse(studyInfo.play_end_location_time),
                media_study_time: JSON.parse(studyInfo.studyTime),
                is_audition: studyInfo.is_audition,
                is_today_study: studyInfo.is_today_study,
                business_type: '110',
                business_id: studyInfo.plan_id,
                collection_id: studyInfo.pb_id,
                chapter_id: studyInfo.pack_id,
                event_type:2,
            }
        });
        return
    }
    if (type == 'pack') {
        clearInterval(setval_read);
        localStorage.removeItem('readMsg');
        is_finished = 1;
    } else if (type == 'pack_media') {
        clearInterval(setval_play);
        localStorage.removeItem('playMsg');
        is_finished = (Number(studyInfo.play_end_location_time) / Number(studyInfo.media_time)) > 0.9 ? 1 : 0
    }
    let studayInfo = [
        {
            business_type: '102', // 商品类型
            business_id: studyInfo.plan_id,         // 商品id
            collection_id: studyInfo.pb_id,         // 书籍ID
            chapter_id: studyInfo.pack_id,          // 拆书包ID
            time_length: JSON.parse(studyInfo.studyTime),       // 学习时长
            start_progress: studyInfo.play_start_location_time ? JSON.parse(studyInfo.play_start_location_time) : 0,                      // 开始的进度 秒 （微信端不记录）
            learning_progress: studyInfo.play_end_location_time ? JSON.parse(studyInfo.play_end_location_time) : 0,                   // 最后阅读到的进度 秒 （微信端不记录）
            total_progress: studyInfo.media_time && type == 'pack_media' ? studyInfo.media_time : 0,            // 音视频总时长
            is_finished: is_finished
        }
    ]
    // 微信端学习时长记录
    saveStudayTime(getType(studyInfo.media_type), JSON.stringify(studayInfo), pro_name, '').then(res => {
        if (res.code == 1) {
            loadingType = ''
            // （结束）音视频时长
            sensorsEvent({
                eventName: 'endStudyMedia',
                eventObject: {
                    media_type:studyInfo.media_type ? studyInfo.media_type : 'audio',
                    media_time:studyInfo.media_time && type == 'pack_media' ? JSON.parse(studyInfo.media_time) : 0,
                    play_start_location_time: JSON.parse(studyInfo.play_start_location_time),
                    play_end_location_time: JSON.parse(studyInfo.play_end_location_time),
                    media_study_time: JSON.parse(studyInfo.studyTime),
                    is_audition: studyInfo.is_audition,
                    is_today_study: studyInfo.is_today_study,
                    business_type: '102',
                    business_id: studyInfo.plan_id,
                    collection_id: studyInfo.pb_id,
                    chapter_id: studyInfo.pack_id,
                    event_type:2,
                }
            });

        } else {
            if (type == 'pack') {
                setStore('readMsg', studyInfo);
            } else if (type == 'pack_media') {
                setStore('playMsg', studyInfo);
            }
        }
    }).catch(err => {

    });
}

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
export const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 获取视频类型
 */
export const getType = media_type => {
    var type = '';
    if(media_type == 'view') {
        type = 'plan'
    } else if (media_type == 'audio') {
        type = 'plan_media'
    } else if (media_type == 'video') {
        type = 'plan_video'
    } else if (media_type == 'short_video') {
        type = 'short_video'
    } else {
        type = 'plan'
    }
    return type
}
